import { MinorBreakRule } from 'constants/MinorBreakRule';
import {
  CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK,
  CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK_NOTE,
  CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME,
  CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME_NOTE,
} from 'translations/constants';

/** Card order: Rule 1, Rule 2. */
export const RULES: MinorBreakRule[] = [MinorBreakRule.CONTINUOUS_WORK, MinorBreakRule.LEGAL_WORK_TIME];

export const RULE_TITLE_KEYS: Record<MinorBreakRule, string> = {
  [MinorBreakRule.CONTINUOUS_WORK]: CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK,
  [MinorBreakRule.LEGAL_WORK_TIME]: CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME,
};

export const RULE_NOTE_KEYS: Record<MinorBreakRule, string> = {
  [MinorBreakRule.CONTINUOUS_WORK]: CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK_NOTE,
  [MinorBreakRule.LEGAL_WORK_TIME]: CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME_NOTE,
};

/** Test-id slugs, so ids stay readable: minor-breaks-continuous-work-… */
export const RULE_SLUGS: Record<MinorBreakRule, string> = {
  [MinorBreakRule.CONTINUOUS_WORK]: 'continuous-work',
  [MinorBreakRule.LEGAL_WORK_TIME]: 'legal-work-time',
};
